import Entity from "entity";

export default class Perfil extends Entity {
    static get collectionUID() {
        return "PerfilUser";
    }
    async initialize() { }

    static async onQuery(collection) {
        return collection;
    }

    static get labelField() {
        return "name";
    }    static get searchColumns() {
        return [
            { field: "name", headerName: "Nome", flex: 2, filter: true },
            { field: "email", headerName: "E-Mail", flex: 2, filter: true },
            {
                field: "tipoPerfil",
                headerName: "Tipo de Perfil",
                flex: 1.5,
                filter: true,
                valueGetter: ({ value }) => {
                    try {
                        if (value === "admin") return "ADMINISTRADOR";
                        if (value === "empresa") return "EMPRESA";
                        if (value === "colaborador") return "COLABORADOR";
                        else return "USUÁRIO";
                    } catch { }
                }
            },            {
                field: "saldoRodadas",
                headerName: "Saldo Rodadas",
                flex: 1,
                filter: true,
                valueGetter: ({ value, row }) => {
                    if (row.tipoPerfil === "empresa") {
                        if (value === "" || value === null || value === undefined) {
                            return "Ilimitado";
                        }
                        return value || 0;
                    }
                    return "-";
                }
            },
            {
                field: "dataFimContrato",
                headerName: "Fim Contrato",
                flex: 1.5,
                filter: true,
                valueGetter: ({ value, row }) => {
                    if (row.tipoPerfil === "empresa") {
                        if (!value) {
                            return "Ilimitado";
                        }
                        return new Date(value).toLocaleDateString('pt-BR');
                    }
                    return "-";
                }
            },
        ];
    }    // Método para verificar se o perfil pode cadastrar rodadas
    canCreateRodadas() {
        if (this.data.tipoPerfil !== "empresa") {
            return { canCreate: false, reason: "Apenas perfis do tipo 'Empresa' podem cadastrar rodadas." };
        }

        // Verifica se o contrato está ativo (apenas se houver data definida)
        if (this.data.dataFimContrato) {
            const fimContrato = new Date(this.data.dataFimContrato);
            const hoje = new Date();
            if (hoje > fimContrato) {
                return { canCreate: false, reason: "Contrato expirado. Renove sua assinatura para continuar cadastrando rodadas." };
            }
        }

        // Verifica saldo de rodadas (apenas se houver saldo definido)
        const saldo = this.data.saldoRodadas;
        
        // Se saldo é vazio, null, undefined ou string vazia = ilimitado
        if (saldo === "" || saldo === null || saldo === undefined) {
            const contratoInfo = this.data.dataFimContrato 
                ? `válido até ${new Date(this.data.dataFimContrato).toLocaleDateString('pt-BR')}`
                : "sem limite de data";
            return { canCreate: true, saldo: "ilimitado", reason: `Rodadas ilimitadas (${contratoInfo})` };
        }

        // Se saldo é um número
        const saldoNumerico = parseInt(saldo);
        if (saldoNumerico <= 0) {
            return { canCreate: false, reason: "Saldo de rodadas esgotado. Entre em contato para adquirir mais créditos." };
        }

        return { canCreate: true, saldo: saldoNumerico };
    }    // Método para consumir uma rodada do saldo
    async consumirRodada() {
        if (this.data.tipoPerfil === "empresa") {
            const saldo = this.data.saldoRodadas;
            
            // Se saldo é vazio/ilimitado, não precisa consumir
            if (saldo === "" || saldo === null || saldo === undefined) {
                return true; // Sucesso, mas sem alterar saldo
            }
            
            // Se tem saldo numérico, verifica e consome
            const saldoAtual = parseInt(saldo) || 0;
            if (saldoAtual > 0) {
                this.data.saldoRodadas = saldoAtual - 1;
                await this.save();
                return true;
            }
            
            return false; // Saldo esgotado
        }
        return false;
    }    // Método para adicionar rodadas ao saldo
    async adicionarRodadas(quantidade) {
        if (this.data.tipoPerfil === "empresa") {
            const saldoAtual = this.data.saldoRodadas;
            
            // Se saldo estava vazio/ilimitado, define como a quantidade adicionada
            if (saldoAtual === "" || saldoAtual === null || saldoAtual === undefined) {
                this.data.saldoRodadas = quantidade;
            } else {
                // Se tinha saldo numérico, soma
                this.data.saldoRodadas = (parseInt(saldoAtual) || 0) + quantidade;
            }
            
            await this.save();
            return true;
        }
        return false;
    }
}